import PropTypes from 'prop-types';
import cx from 'classnames';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import TabsBody from './Body';

const View = ({ data, id, className, path, metadata }) => (
  <div
    className={cx(
      'block',
      'csjTabs',
      `tabs-variant-${data?.variant || 'text'}`,
      className,
    )}
  >
    <TabsBody data={data} blockId={id} path={path} metadata={metadata} />
  </div>
);

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.string,
  className: PropTypes.string,
  path: PropTypes.string,
  metadata: PropTypes.objectOf(PropTypes.any),
};

export default withBlockExtensions(View);
